module.exports = function getResource(label, vars = []) {
    let resources = {
        filterBy: 'Filter by',
        filter: 'Filter',
        resetAllFilters: 'Reset all filters',
        clearAll: 'Clear All',
        reset: 'Reset',
        done: 'Done',
        showResults: 'Show Results'
    };

    return resources[label];
};
